/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./styles/sign-in-up.css";
import { useNavigate } from "react-router-dom";

import {
  LoadingOutlined,
  LoginOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import { Form, Input, Button, Row, Col, Spin, Popconfirm, message } from "antd";

import ImagesSlider from "../components/ImagesSlider";
import MaintenanceModal from "../components/AdminComponents/Modals/MaintenanceModal";
import { useSelector } from "react-redux";
import Axios from "../api/Axios";
import {
  EMPLOYEE_EARLY_LOGIN,
  REDIRECT_COACHING,
  REDIRECT_LEARNING,
} from "../config";
import { useDispatch } from "react-redux";
import { userData } from "../store/slices/UserInfo";
import { allowedRoles } from "../components/icons/ApplicationColor";
import { setClientData } from "../store/slices/OrgDetail";
import { MAIN_LOGO_BIG } from "../ImagesSrc";
const LocationSignIn = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [microsoftLoader, setMicrosoftLoader] = useState(false);

  const namingData = useSelector((state) => state.orgdeatil);
  const { loginPayload } = namingData;

  const history = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      history("/home");
    }
  }, [history]);

  useEffect(() => {
    const inputField = document.getElementById("inputFieldId");
    if (inputField) {
      inputField.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      });
    }
  }, []);

  const [form] = Form.useForm();

  const [modalVisible, setModalVisible] = useState(false);

  const handleModalClose = () => {
    setModalVisible(false);
  };
  const [visible, setVisible] = useState(false);
  const [timer, setTimer] = useState(120);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);
  const SendOtp = async () => {
    const tokenCheck = localStorage.getItem("OtpSent");
    if (!tokenCheck) {
      setMicrosoftLoader(true);
      try {
        const payload = {
          email: loginPayload?.email,
          latitude: loginPayload?.latitude,
          longitude: loginPayload?.longitude,
          microsoft_access_token: loginPayload?.microsoft_access_token,
        };
        await Axios.post("/sendotpmail/", payload);
        localStorage.setItem("OtpSent", true);
        //console.log(res.data);
        setMicrosoftLoader(false);
        // redirectUser(res);
      } catch (err) {
        //console.log(err?.response?.data?.detail);
        OtpSendFailed();
        setMicrosoftLoader(false);
      }
    }
  };
  const ResendOtp = async () => {
    try {
      const payload = {
        email: loginPayload?.email,
        latitude: loginPayload?.latitude,
        longitude: loginPayload?.longitude,
        microsoft_access_token: loginPayload?.microsoft_access_token,
      };
      await Axios.post("/sendotpmail/", payload);
      ResendSuccess();
      setTimer(120);
      //console.log(res.data);
    } catch (err) {
      OtpSendFailed();
      //console.log(err?.response?.data?.detail);
    }
  };
  useEffect(() => {
    SendOtp();
  }, []);
  const handleResend = () => {
    ResendOtp();
  };

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };
  const OtpSubmit = async (values) => {
    //console.log("Form values on submit:", values);
    const payload = {
      ...values,
      email: loginPayload?.email,
      longitude: loginPayload?.longitude,
      latitude: loginPayload?.latitude,
      microsoft_access_token: loginPayload?.microsoft_access_token,
    };

    try {
      const res = await Axios.post("/verifyotp/", payload);
      //console.log(res.data);
      if (res?.data?.location_access) {
        localStorage.setItem("token", res.data.token);
        redirectUser(res);
        dispatch(
          setClientData({
            loginPayload: {},
          })
        );
      }
    } catch (err) {
      setLoading(false);
      //console.log(err);
      const text =
        err?.response?.data?.counter !== undefined
          ? ` Remaining Attempts ${3 - err?.response?.data?.counter}`
          : "";
      FalseOtp(`${err?.response?.data?.details}${text}`);
    }
  };
  const loadIframe = () => {
    return new Promise((resolve) => {
      const iframe = document.createElement("iframe");
      iframe.src = EMPLOYEE_EARLY_LOGIN;
      iframe.style.display = "none";

      iframe.addEventListener("load", () => {
        resolve();
      });

      document.body.appendChild(iframe);
    });
  };
  const redirectUser = async () => {
    try {
      const res = await Axios.get("/auth-user/");
      setLoading(false);
      dispatch(userData(res.data));
      const isAdmin = res.data.roles.some((app) =>
        allowedRoles.includes(app.key_name)
      );
      if (isAdmin) {
        localStorage.setItem("isAdmin", "true");
        // Do something else if needed
        //console.log("role set");
      } else {
        localStorage.removeItem("isAdmin");
        // Do something else if needed
      }
      setMicrosoftLoader(false);
      if (res.data.default_application?.name) {
        const iframePromises = [];
        iframePromises.push(loadIframe());
        await Promise.all(iframePromises);
        if (res.data.default_application.name === "Trak Learning") {
          window.location.href = REDIRECT_LEARNING;
        } else if (res.data.default_application.name === "Trak Coaching") {
          window.location.href = REDIRECT_COACHING;
        } else {
          window.location.href = res.data.default_application.url;
        }
      } else {
        setMicrosoftLoader(false);
        const iframePromises = [];
        iframePromises.push(loadIframe());
        await Promise.all(iframePromises);
        history("/home");
      }
    } catch (err) {
      setLoading(false);
      //console.log(err);
      if (err.response?.status === 403 || err.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.clear();
        history("/");
      } else {
        //console.log("----coming here----");
        localStorage.removeItem("token");
        localStorage.clear();
        history("/");
      }
    }
  };

  const handleInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
  };
  const FalseOtp = (text) => {
    messageApi.open({
      type: "error",
      content: text,
      duration: 9,
    });
  };
  const OtpSendFailed = () => {
    messageApi.open({
      type: "error",
      content: "Mail services is down for now. Please try again later",
      duration: 6,
    });
  };
  const ResendSuccess = () => {
    messageApi.open({
      type: "success",
      content: "OTP Resent successfully",
      duration: 6,
    });
  };
  return (
    <Spin spinning={microsoftLoader}>
      {contextHolder}
      <div className="main-co">
        <div
          className="cont"
          style={{
            height: "53rem",
          }}
        >
          <div className="left">
            <img
              alt=""
              src={MAIN_LOGO_BIG}
              className="logo1"
              height={"37px"}
              width={"150px"}
            />
            <div className="signIn_text1">OTP Required</div>

            <div className="text-para-location">
              A login attempt from a different location has been detected.
              Please enter the 6-digit OTP sent to your email{" "}
              <strong>{loginPayload?.email}</strong>.
            </div>

            <Form
              form={form}
              initialValues={{
                otp: "",
              }}
              onFinish={(values) => {
                if (!loading) {
                  form
                    .validateFields()
                    .then(() => {
                      //console.log(values);
                      setLoading(true);
                      OtpSubmit(values);
                    })
                    .catch((errorInfo) => {
                      //console.log("Form validation failed:", errorInfo);
                    });
                }
              }}
            >
              <Row gutter={13} style={{ marginTop: "6rem" }}>
                <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                  <Form.Item
                    name="otp"
                    rules={[
                      {
                        required: true,
                        message:
                          "Please enter the 6-digit OTP sent to your email",
                        len: 6,
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter 6-digit OTP"
                      className="input-col1"
                      type="text"
                      maxLength={6}
                      style={{
                        color: "black",
                        letterSpacing: "0.5rem",
                        textAlign: "center",
                        fontSize: "1.5rem",
                      }}
                      onInput={handleInput}
                    />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Popconfirm
                    title={
                      timer > 0
                        ? `You can resend OTP in ${Math.floor(timer / 60)}:${(
                            "0" +
                            (timer % 60)
                          ).slice(-2)}`
                        : "Click to resend OTP"
                    }
                    onConfirm={handleResend}
                    onCancel={() => setVisible(false)}
                    onOpenChange={handleVisibleChange}
                    open={visible}
                    okText="Resend"
                    cancelText="Cancel"
                    okButtonProps={{ disabled: timer > 0 }}
                  >
                    <QuestionCircleOutlined
                      onMouseEnter={() => setVisible(true)}
                      // onMouseLeave={() => setVisible(false)}
                      style={{
                        color: "gray",
                        fontSize: "2.4rem",
                        paddingTop: "12.5px",
                        verticalAlign: "middle",
                        cursor: "pointer",
                      }}
                    />
                  </Popconfirm>
                </Col>
              </Row>

              <Row gutter={10}>
                <Col
                  xs={20}
                  sm={20}
                  md={21}
                  lg={21}
                  xl={21}
                  style={{ marginTop: "1.5rem" }}
                >
                  <Form.Item>
                    <Button
                      className="button-29"
                      // onClick={multipleUsers ? handleNext4 : handleNext3}
                      type="primary"
                      htmlType="submit"
                      style={{
                        marginTop: "0rem",
                        cursor: loading ? "not-allowed" : "pointer",
                      }}
                      disabled={loading}
                    >
                      SUBMIT
                      {loading ? (
                        <LoadingOutlined />
                      ) : (
                        <LoginOutlined style={{ fontSize: "17px" }} />
                      )}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
          <ImagesSlider />
        </div>
      </div>
      <MaintenanceModal visible={modalVisible} onClose={handleModalClose} />
    </Spin>
  );
};

export default LocationSignIn;
